










































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import moment from 'moment';

import { STORE_KEY, store } from './_store';

import TitleBar from '@/components/Elements/TitleBar.vue'
import DealsByStatus from './DealsByStatus.vue'

@Component({
  computed: {
    ...mapState('ubic', [
      'actor'
    ]),

    ...mapState(STORE_KEY, [
      'deliveryDate', 'cityId',
      'dataRequested', 'dataLoading', 'dataLoaded',
      'pipeline', 'statuses'
    ]),
    // ...mapGetters(STORE_KEY, [
    //   'currentEmployeeFilterValue'
    // ]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      // 'changeFilterValue'
    ])
  },
  components: {
    TitleBar,
    DealsByStatus
  }
})
export default class DeliverySheetBoard extends Vue {

  actor!: any;
  filter!: any;
  employees!: any[];
  
  get titleStack () {
    const tags = [
      'Воронки', 
    ]
    // @ts-ignore
    if (this.pipeline) { tags.push(this.pipeline.name); }
    
    return tags
  }

  changeFilterValue({field, newValue}: any) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        [field]: field == 'deliveryDate' ? moment(newValue).format('YYYY-MM-DD') : newValue
      }
    })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange()
  }
  
  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    console.log('!!!', this.$route.params)
    this.$store.dispatch(`${STORE_KEY}/setFilterValue`, {
        ...this.$route.params
      });
  }

}
